import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    slots: {
        label: 'font-(family-name:--primary-font) text-base font-bold'
    }
} satisfies NuxtUiTheme['separator'];
